import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetScrapFinanceAccountsRequestModel, GetScrapFinanceAccountsResponseModel } from "@/features/accounts/scrap-finance/services/get-accounts-model";

export class GetScrapFinanceAccountsApi {
  /**
   * 銀行口座取得API
   */
  public getScrapFinanceAccounts = async (
    param: GetScrapFinanceAccountsRequestModel
  ): Promise<GetScrapFinanceAccountsResponseModel[]> => {
    const path = `/api/scrapingaccounts/finances`;
    const res = await ApiClient.instance.get<GetScrapFinanceAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
